export const getWidthScreen = (get_value = false) => {
    var width = window.innerWidth;
    if (get_value) {
        return parseInt(width);
    }
    var width_screen_breakpoints = {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
    };
    if (width > width_screen_breakpoints.lg) {
        return 'xl';
    } else if (width > width_screen_breakpoints.md) {
        return 'lg';
    } else if (width > width_screen_breakpoints.sm) {
        return 'md';
    } else if (width > width_screen_breakpoints.xs) {
        return 'sm';
    }
};

export const checkLogin = (login) => {
    if (!login || !login.length || login.length >= 100) {
        return false;
    }

    return login.match(/^[a-zA-Zа-яА-Я0-9_\s\.]+$/);
};

export const checkPhone = (phone) => {
    // fix format - 79101234567 (11 symbols)
    if (!phone || !phone.length || phone.length != 11) {
        return false;
    }

    return true;
};

export const checkEmail = (email) => {
    if (!email || !email.length) {
        return false;
    }
    return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const checkFio = (fio) => {
    if (!fio || !fio.length) {
        return false;
    }

    fio = fio.trim();
    let array_strings = fio.split(' ');

    if (!array_strings || array_strings.length !== 3) {
        return false;
    }

    let is_empty = false;
    array_strings.map((value) => {
        if (!value) {
            is_empty = true;
        }
    });

    if (is_empty) {
        return false;
    }

    return true;
};

// плавный скролл до элемента
export const scrollToElement = (element, parent) => {
    var target = $(element);

    if (typeof parent === 'undefined') {
        parent = 'html, body';
    }

    if (target.length) {
        $(parent).animate(
            {
                scrollTop: target.offset().top,
            },
            500,
            function () {
                var $target = $(target);
                $target.focus();
                if ($target.is(':focus')) {
                    return false;
                } else {
                    $target.attr('tabindex', '-1');
                    $target.focus();
                }
            }
        );
    }
};
